module.exports = __webpack_public_path__ + "images/fa-you-missed-it-bg.jpg";